// extracted by mini-css-extract-plugin
export default {"container":"Otp_container__1SZGa"};